import React from 'react';
import PropTypes from 'prop-types';

class AlertMessage extends React.Component {
  constructor(props) {
    super(props);

    const {
      alertPopup,
    } = this.props;

    this.state = {
      type: '',
      isShow: false,
      message: '',
      stamp: ''
    };
    this.autoHideMessage = this.autoHideMessage.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      alertPopup
    } = this.props;

    if (alertPopup.stamp !== prevProps.alertPopup.stamp && alertPopup.isShow ) {
      this.setState({
        type: alertPopup.type,
        isShow: alertPopup.isShow,
        message: alertPopup.message,
        stamp: Date.now()
      }, () => this.autoHideMessage());
    }
  }

  closeAlert() {
    this.setState({isShow: false});
  }

  autoHideMessage() {
    const self = this;

    setTimeout(() => {
      self.setState({
        isShow: false
      });
    }, 5000);
  }

  render() {
    const {
      type,
      isShow,
      message
    } = this.state;

    const headings = {
      success: '自動計算しました',
      info: 'お知らせ',
      warning: '日本語入力',
      error: 'エラーがありました'
    };

    return (
      <div className={`alert-component alert-${type} ${isShow ? 'd-block' : 'd-none'}`}>
        <button aria-label="Close" className="btn-close" data-bs-dismiss="alert" onClick={() => this.closeAlert()} type="button"></button>
        <h4> {headings[type] || headings.error} </h4>
        { message }
      </div>
    );
  }
}


AlertMessage.propTypes = {
  alertPopup: PropTypes.object
};
export default AlertMessage;
